import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

export default function WorkAreaFormGroup({
  name,
  children,
  label,
  isValid = true,
  helpText = '',
}) {
  return (
    <>
      <Form.Group
        as={Row}
        controlId={name}
        className="m-0 d-flex justify-content-between align-items-center"
        validated={isValid ? null : 'error'}
      >
        <Form.Label column sm={6} className="p-1">
          {label}
        </Form.Label>
        <Col sm={6} className="align-self-center">
          {children}
        </Col>
      </Form.Group>
      {!isValid && helpText.length > 0 ? (
        <p className="text-center text-danger">{helpText}</p>
      ) : null}
    </>
  );
}
